/*
 * @Author: Wang Wenmao
 * @Date: 2023-11-01 15:31:41
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2023-12-26 11:12:19
 * @Description: 添加优惠券
 */
import React, { Component, Fragment } from 'react';
import { Button, Modal, Table, Radio, Form, Input, Spin } from 'antd';

import { services } from '@comall-backend-builder/core';
import './index.less';

import { errorHandle } from '../../services';

const api = services.api;

const couponType = {
    PRODUCT: '商品金额券',
    REPAIR: '维修金额券',
    MAINTAIN: '养护金额券',
    FREIGHT: '运费券',
    RECOVERY: '加价回收券',
};

export interface IProps {
    submit: any;
    mobile: string;
    item: any[];
    coupons: any[];
    useExecutePrice: string;
}

interface IState {
    visible: boolean;
    value: string;
    selectedRowKeys: string[];
    radioValue: string;
    list: any[];
    couponData: any;
    loading: boolean;
}

export class AddCoupon extends Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            visible: false,
            value: '',
            selectedRowKeys: [],
            radioValue: '1',
            list: [],
            couponData: {},
            loading: false,
        };
    }

    columns = [
        {
            title: '优惠券类型',
            dataIndex: 'type',
            key: 'type',
            render: (text: string) => {
                return <div>{couponType[text]}</div>;
            },
        },
        {
            title: '优惠券名称',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: '优惠券ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '优惠券有效期',
            dataIndex: 'time',
            key: 'time',
            render: (text: string, record: any) => {
                return (
                    <div>
                        {record.beginTime} 至 {record.endTime}
                    </div>
                );
            },
        },
        {
            title: '使用门槛',
            dataIndex: 'conditionValue',
            key: 'conditionValue',
            render: (text: any, record: any) => {
                return (
                    <div>
                        满{record.conditionValue}
                        {record.condition === 'GRAM' || record.condition === 'MONEY' ? '元' : '件'}
                        可用
                    </div>
                );
            },
        },
        {
            title: '优惠额度/折扣力度',
            key: 'preferential',
            render: (_: any, record: any) => {
                const types = {
                    SUBTRACT: `减¥${record.price}元`,
                    DISCOUNT: `打${record.price}折`,
                };
                return <div>{types[record.moneyUnit]}</div>;
            },
        },
    ];

    // 根据手机号获取优惠券
    getCouponByPhoneNumber = () => {
        const { mobile: phoneNumber, item, coupons } = this.props;
        this.setState({ loading: true });
        const promotionProductBaseInfos = item.map((el) => ({
            couponStatus: '0',
            queryCondition: '',
            skuID: el.id.toString(),
            quantity: el.quantity,
            executePrice:
                this.props.useExecutePrice === 'true'
                    ? el.executePrice.toString()
                    : el.originPrice.toString(),
        }));

        const param = {
            promotionProductBaseInfos,
            promotionSelectVO: {
                consigneeId: '0',
                coupons,
                multiPromotions: [],
                multiPromotionsPresents: {},
                singlePromotions: {},
                singlePromotionsPresents: {},
                virtualType: 'NORMAL',
            },
            useExecutePrice: this.props.useExecutePrice,
        };

        const apiPath = `/8001/order/getCouponByPhoneNumber/${phoneNumber}?param=${JSON.stringify(
            param
        )}`;
        api.get({}, { apiPath })
            .then((res: any) =>
                this.setState(
                    {
                        couponData: {
                            list: res.availableCouponsList,
                            unList: res.unAvailableCouponsList,
                        },
                    },
                    this.filterData
                )
            )
            .catch(errorHandle)
            .finally(() => this.setState({ loading: false }));
    };

    filterData = () => {
        const {
            radioValue,
            value,
            couponData: { list, unList },
        } = this.state;
        const data = radioValue === '1' ? list : unList;

        if (value === '') {
            this.setState({ list: data });
        } else {
            const newData = data.filter((item: any) => {
                return item.id.includes(value) || item.title.includes(value);
            });
            this.setState({ list: newData });
        }
    };

    clearAll = () => this.setState({ value: '', selectedRowKeys: [], radioValue: '1' });

    showModal = () => this.setState({ visible: true }, this.getCouponByPhoneNumber);

    handleOk = () => {
        const { selectedRowKeys, list } = this.state;
        const { submit } = this.props;
        if (selectedRowKeys.length === 0) {
            return;
        }

        const current = list.find((item) => item.id === selectedRowKeys[0]);
        this.setState({ visible: false }, () => {
            submit(current);
            this.clearAll();
        });
    };

    handleCancel = () => this.setState({ visible: false }, this.clearAll);

    handleChangeRadio = ({ target }) =>
        this.setState({ radioValue: target.value }, this.filterData);

    handleClear = () => this.setState({ value: '' }, this.filterData);

    handleSearch = () => this.filterData();

    handleChangeInput = ({ target }) => this.setState({ value: target.value });

    render() {
        const { visible, value, radioValue, selectedRowKeys, list, loading } = this.state;
        const { coupons } = this.props;
        const title = radioValue === '1' ? '可用' : '不可用';
        const rowSelection: any = {
            type: 'radio',
            selectedRowKeys,
            getCheckboxProps: (record: any) => {
                if (radioValue === '2') {
                    return { disabled: true };
                } else {
                    return { disabled: coupons.length > 0 };
                }
            },
            onChange: (selectedRowKeys: any) => this.setState({ selectedRowKeys }),
        };

        return (
            <Fragment>
                <Button type="primary" onClick={this.showModal}>
                    添加优惠券
                </Button>
                <Modal
                    title={`${title}优惠券`}
                    width={1200}
                    centered
                    visible={visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    {loading ? (
                        <Spin style={{ width: '100%', height: '100%' }} />
                    ) : (
                        <>
                            <Radio.Group
                                value={radioValue}
                                buttonStyle="solid"
                                onChange={this.handleChangeRadio}
                            >
                                <Radio.Button value="1">可用</Radio.Button>
                                <Radio.Button value="2">不可用</Radio.Button>
                            </Radio.Group>
                            <Form layout="inline">
                                <Form.Item label="关键词">
                                    <Input
                                        placeholder="请输入优惠券名称/优惠券ID"
                                        value={value}
                                        onChange={this.handleChangeInput}
                                    />
                                </Form.Item>

                                <Form.Item>
                                    <Button onClick={this.handleClear}>重置</Button>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: 10 }}
                                        onClick={this.handleSearch}
                                    >
                                        查询
                                    </Button>
                                </Form.Item>
                            </Form>

                            <Table
                                rowKey="id"
                                rowSelection={rowSelection}
                                dataSource={list}
                                columns={this.columns}
                            />
                        </>
                    )}
                </Modal>
            </Fragment>
        );
    }
}
